import { CircularProgress } from '@mui/material';
import { ContainerLoading } from './style';

export default function Loading() {
  return (
    <ContainerLoading>
      <CircularProgress style={{ width: 100, height: 100 }} />
    </ContainerLoading>
  );
}
